import React, { useState, useEffect, useMemo } from "react";
import styles from "./Redirect.module.css";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

export const Redirect = () => {
  const [showFullDiv, setShowFullDiv] = useState(false);

  // takes user from URL: ?user=email@domain.com
  const userFromUrl = useMemo(() => {
    return new URLSearchParams(window.location.search).get("user");
  }, []);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (showFullDiv) {
      timer = setTimeout(() => {
        setShowFullDiv(false);
      }, 3000);
    }

    return () => clearTimeout(timer);
  }, [showFullDiv]);

  const handleButtonClick = () => {
    setShowFullDiv((prev) => !prev);
  };

  // if user does not exist, still redirect without param
  const redirectUrl = userFromUrl
    ? `https://inteligencia.safiraenergia.com.br?user=${encodeURIComponent(
        userFromUrl
      )}`
    : "https://inteligencia.safiraenergia.com.br";

  return (
    <div>
      <div className={styles.buttonDiv}>
        <button onClick={handleButtonClick}>
          <MdOutlineKeyboardArrowDown className={styles.inactiveIcon} />
        </button>
      </div>

      <div
        className={`${styles.redirectDiv} ${
          showFullDiv ? styles.active : styles.inactive
        }`}
      >
        <a href={redirectUrl}>
          <button style={{ width: "100%" }}></button>
        </a>

        <div className={styles.buttonDivActive}>
          <button onClick={handleButtonClick}>
            <MdOutlineKeyboardArrowDown />
          </button>
        </div>
      </div>
    </div>
  );
};
